export const environment = {
  production: false,
  id: '59',
  baseUrl: 'https://59.superlikerslabs.com',
  photosPath: 'https://superlikers-staging.s3.amazonaws.com/uploads/upload-photo',
  documentsPath: 'https://superlikers-staging.s3.amazonaws.com/uploads/maquetacion/upload_documents/'
}
